import {Injectable} from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {Observable} from "rxjs";
import {finalize} from "rxjs/operators";

import {LoaderService} from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private requestCount = 0;

  constructor(public loaderService: LoaderService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.headers.has('No-Loader')){
      req = req.clone({
        headers: req.headers.delete('No-Loader')
      });
      return next.handle(req);
    }
    this.requestCount++;
    this.loaderService.show();
    return next.handle(req).pipe(
      finalize(() => {
        this.requestCount--;
        if (this.requestCount == 0) {
          this.loaderService.hide();
        }
      })
    );
  }
}
